const widgets = document.querySelectorAll(".selling-widget-wrapper");
const purchaseInputs = document.querySelectorAll("input[name='variant-option']");
const nailsCountWrapper = document.querySelector(".product-benefits .nails");
const subscriptionFrequencyWrapper = document.querySelector(".product-benefits .frequency");
const priceWrapper = document.querySelector(".product-benefits .nail-price");
const otpPriceWrapper = document.querySelector(".one-time-purchase__price");
const giftsWrapper = document.querySelector(".selling-widget__gifts .offer-widget__gifts");

purchaseInputs.forEach((purchaseInput)=>{
  purchaseInput.addEventListener("change", function(e){   
    const currentValue = purchaseInput.value;
    const featuredImage = purchaseInput.dataset.image;
    const giftCount = purchaseInput.dataset.nails;
        widgets.forEach((widget)=>{
          if(currentValue!=widget.getAttribute("data-purchase")){
           !widget.classList.contains("widget-hide") ? widget.classList.add("widget-hide") : null;
           widget.classList.contains("widget-active") ? widget.classList.remove("widget-active") : null;
          } else{
            widget.classList.contains("widget-hide") ? widget.classList.remove("widget-hide") : null;
            !widget.classList.contains("widget-active") ? widget.classList.add("widget-active") : null;
            const activeRadio = document.querySelector(".widget-active .selling-widget__plan input[type='radio']:checked");
            nailsCountWrapper ?   nailsCountWrapper.innerText =  purchaseInput.dataset.nails: null;     
            subscriptionFrequencyWrapper ?   subscriptionFrequencyWrapper.innerText =  purchaseInput.dataset.frequency: null; 
            priceWrapper ?   priceWrapper.innerText =  purchaseInput.dataset.price: null; 
            otpPriceWrapper ?   otpPriceWrapper.innerText = "(" + purchaseInput.dataset.price + ")": null; 
          }
        })
    if(giftsWrapper && giftCount){
      giftsWrapper.setAttribute("data-gift", giftCount)
    }
    if(featuredImage){
        const sliderThumb = purchaseInput.closest(".product").querySelector(`.thumbnail-list__item[data-target='${featuredImage}'] button`);
        sliderThumb.click();
      }
  })
})
window.addEventListener("pageshow", function(e){
    const purchaseInput = document.querySelector(".variants-selector__variant input:checked");
    const currentValue = purchaseInput.value;
    const featuredImage = purchaseInput.dataset.image;
    const giftCount = purchaseInput.dataset.nails;
        widgets.forEach((widget)=>{
          if(currentValue!=widget.getAttribute("data-purchase")){
           !widget.classList.contains("widget-hide") ? widget.classList.add("widget-hide") : null;
           widget.classList.contains("widget-active") ? widget.classList.remove("widget-active") : null;
          } else{
            widget.classList.contains("widget-hide") ? widget.classList.remove("widget-hide") : null;
            !widget.classList.contains("widget-active") ? widget.classList.add("widget-active") : null;
            const activeRadio = document.querySelector(".widget-active .selling-widget__plan input[type='radio']:checked");
            nailsCountWrapper ?   nailsCountWrapper.innerText =  purchaseInput.dataset.nails: null;     
            subscriptionFrequencyWrapper ?   subscriptionFrequencyWrapper.innerText =  purchaseInput.dataset.frequency: null; 
            priceWrapper ?   priceWrapper.innerText =  purchaseInput.dataset.price: null; 
            otpPriceWrapper ?   otpPriceWrapper.innerText = "(" + purchaseInput.dataset.price + ")": null; 
          }
        })
    if(giftsWrapper && giftCount){
      giftsWrapper.setAttribute("data-gift", giftCount)
    }
    if(featuredImage){
        const sliderThumb = purchaseInput.closest(".product").querySelector(`.thumbnail-list__item[data-target='${featuredImage}'] button`);
        sliderThumb.click();
      }
})
async function addAllToCart(button){
  button.classList.add("loading");
  const formData = [];
  const checkedInput = document.querySelector("input[name='variant-option']:checked");
  const variantId = checkedInput.value;
  const productId = document.querySelector(".selling-widget input[name='product_id']").value;
  const collectionId = document.querySelector("#mySidenav").getAttribute("data-collection-id");
  const quantity = 1;
  let sellingPlan;
  const sellingPlanID = checkedInput.previousElementSibling?.getAttribute("data-selling-plan");
  sellingPlanID ? sellingPlan = sellingPlanID : sellingPlan = null;  
  
  const selections = [];
  const _contents = [];
  const bundleProducts = document.querySelectorAll(".selling-widget-wrapper.widget-active .hh-upsell-btn.hh-bg-image");
  let productCounter = 1;
  bundleProducts.forEach((bundleProduct)=>{
    _contents.push(`${productCounter}x ${bundleProduct.dataset.title}`);
			selections.push({
				collectionId: collectionId,
				externalProductId: bundleProduct.dataset.productId,
				externalVariantId: bundleProduct.dataset.variantId,
				quantity: 1,
			}); 
    })
	var contentsString = _contents.join("\n");
	const bundleProductData = {
		productId: productId,
		variantId: variantId,
		sellingPlan: sellingPlan,
	};
	const bundle = {
		externalVariantId: bundleProductData.variantId,
		externalProductId: bundleProductData.productId,
		selections: selections,
	};
    const rbId = await recharge.bundle.getBundleId(bundle);


	// var mainProduct = {
	// 	id: product_id,
	// 	quantity: product_qty,
	// 	properties: {
	// 		_rb_id: rbId,
	// 		Content: contentsString,
	// 	},
	// };

  const gifts = document.querySelectorAll(".product-gifts .offer-widget__gift[data-id]");
  if(gifts && gifts.length > 0){
    if(document.querySelector(".offer-widget__gifts[data-gift='3']")){
      let newArray = Array.from(gifts).slice(0, -2);
      newArray.forEach((gift)=>{
        formData.push({ id: gift.dataset.id, quantity: 1 });
      })
    } else{
      gifts.forEach((gift)=>{
        formData.push({ id: gift.dataset.id, quantity: 1 });
      })
    }

  }
  formData.push(
    { id: variantId, 
      quantity: parseInt(quantity), 
      properties: {
			_rb_id: rbId,
			Content: contentsString,
		},
    }
  );
  sellingPlan ? formData[formData.length - 1].selling_plan = sellingPlan : null;
  await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: formData }),
  })
  .then(response => response.json())
  .then(data => {
    if(button.getAttribute("data-checkout")){
      button.classList.remove("loading");
      window.location.href = '/checkout';
    } else{
      window.SLIDECART_UPDATE(function(){
        button.classList.remove("loading");
        window.SLIDECART_OPEN();
      });
    }

    

    
  })
  .catch(error => {
      console.error('Error adding to cart:', error);
  });

}
const buyButtons = document.querySelectorAll(".selling-widget__button");
 buyButtons.forEach((buyButton)=>{
       buyButton.addEventListener("click", function(e){
       addAllToCart(buyButton)
    
  })  
})